import React, { Component } from 'react';

class RowHistorialIntentos extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let {valor,index} = this.props;
        let claseFila = index % 2 == 0 ? 'FontHistorialLogBlanco' : 'FontHistorialLogGris';
        let descripcionError = "",fecha="",hora="", textoToolTip = "";

        //validación para el largo del mensaje de error, caso que supere los 58 length se corta y pone en tooltip
        if(valor.MotivoRechazo && valor.MotivoRechazo.length > 58){
            textoToolTip = valor.MotivoRechazo;
            descripcionError = valor.MotivoRechazo.substr(0,55) + "...";
        }else{
            descripcionError = valor.MotivoRechazo;
            textoToolTip = "";
        }
        
        if(valor.Fecha.includes("T")){
            let fechaAux = valor.Fecha.split("T");
            fecha = fechaAux[0];
            hora = fechaAux[1].substr(0,5);
            fecha = fecha + " " + hora;
        }


        return (
        <tr className={'paddingLeftL  paddingTopBottom ' + claseFila}>
            <td style={{width:"20%"}}>
                {valor.SagaId}
            </td>
            <div data-toggle="tooltip" data-title={textoToolTip} >
                <td style={{paddingRight:"10px", paddingTop:"15px", width:"65%"}} >
                    {descripcionError}
                </td>
            </div>
            <td style={{width:"15%"}}>
                {fecha}
            </td>
        </tr>
        )

    }
}

export default RowHistorialIntentos;